<template>
  <footer class="page-footer">
    Copyright ©2023 成都迦美云创科技有限公司 版权所有
  </footer>
</template>

<script>
export default {
  name: 'PageFooter'
}
</script>

<style lang="scss" scoped>
.page-footer {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  color: #7f8fa4;
  font-size: 12px;
  background-color: #ffffff;
  flex-shrink: 0;
  text-align: center;
}
</style>
